import { nextTick } from 'vue'
import { refreshedSessionCookie } from '~/utils/sessionCookie'

export const useAuth = () => {
  const token = useCookie<string | null>('authToken', {
    default: () => null,
  })
  const termsAcceptanceRequired = useCookie<string | boolean | null>(
    'termsAcceptanceRequired',
    {
      default: () => null,
    },
  )
  const onboardingRequired = useCookie<string | boolean | null>(
    'onboardingRequired',
    {
      default: () => null,
    },
  )
  const setToken = async (value: string) => {
    token.value = value
    // Let useCookie synchronize its reactive value before restoring the
    // server's expiry; its default client-side write is a session cookie.
    await nextTick()
    document.cookie = refreshedSessionCookie(
      value,
      window.location.protocol === 'https:',
    )
  }
  const clearCookie = () => {
    token.value = null
    termsAcceptanceRequired.value = null
    onboardingRequired.value = null
  }
  return {
    clearCookie,
    setToken,
    token,
    termsAcceptanceRequired,
    onboardingRequired,
    // Nuxt deserializes an unquoted cookie value of `true` as a boolean, while
    // client-side assignments may remain strings. Normalize both forms.
    requiresTermsAcceptance: computed(
      () => String(termsAcceptanceRequired.value) === 'true',
    ),
    requiresOnboarding: computed(
      () => String(onboardingRequired.value) === 'true',
    ),
    isAuthenticated: computed(() => !!token.value),
  }
}
